import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TailwindMerge } from '@shared/src/interfaces/TwMerge.interface';
import { StepperItem } from '@shared/src/lib/components/stepper/stepper-item/stepper-item.interface';
import { CheckIconComponent } from '@shared/src/lib/icons/check-icon/check-icon.component';
import { StatusChip } from '@shared/src/lib/components/status-chip/status-chip.interface';
import { SyncIconComponent } from '@shared/src/lib/icons/sync-icon/sync-icon.component';

@Component({
  selector: 'lib-stepper-item',
  standalone: true,
  imports: [CheckIconComponent, CommonModule, SyncIconComponent],
  templateUrl: './stepper-item.component.html',
  styleUrl: './stepper-item.component.css',
})
export class StepperItemComponent extends TailwindMerge {
  @Input() option: StepperItem.WorkflowOption;
  @Input() activeStepper: StepperItem.WorkflowOption | null = null;
  readonly STATUS = StatusChip.AdirStatus;
  readonly FDP_STATUS = StatusChip.FdpStatus;
  readonly STEPPER = StepperItem.STEPPER_OPTIONS_LABEL;
  readonly FDP_STEPPER = StepperItem.FDP_STEPPER_OPTIONS_LABEL;
}
